// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmPropertyUnitsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Path,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Path,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Path,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants,
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingOptionsDto,
  AccountViewPropertyUnitsResponseDto,
  AccountViewPropertyUnitStatusDto,
  AccountViewPropertyUnitTenantsResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ListParams {
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}
interface TenantsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Options = UseQueryOptions<
  AccountViewPropertyUnitsResponseDto,
  unknown,
  AccountViewPropertyUnitsResponseDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table units view
 */
export const useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list.getKey =
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_queryOptions = (
  getParams: OptionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table row options for a unit
 */
export const useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options = (
  getParams: OptionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options.getKey =
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Options = UseQueryOptions<
  AccountViewPropertyUnitStatusDto,
  unknown,
  AccountViewPropertyUnitStatusDto,
  readonly [string, StatusParams]
>;

const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_GetKey = (getParams: StatusParams) =>
  [RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_queryOptions = (
  getParams: StatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table unit status cell
 */
export const useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status = (
  getParams: StatusParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status.getKey =
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_GetKey;

export type RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Options = UseQueryOptions<
  AccountViewPropertyUnitTenantsResponseDto,
  unknown,
  AccountViewPropertyUnitTenantsResponseDto,
  readonly [string, TenantsParams]
>;

const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_GetKey = (getParams: TenantsParams) =>
  [RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_queryOptions = (
  getParams: TenantsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table tenant names for a unit
 */
export const useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants = (
  getParams: TenantsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants.getKey =
  RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_GetKey;
